export default {

    getChannel(sort = 'dsds') {
        console.log('getChannel',sort);
        return
    }

};



// WEBPACK FOOTER //
// ./resources/assets/js/store/location.js